import { Button } from "../ui/button"
import { Link } from "react-router-dom"
import { AlertCircle } from "lucide-react"

export default function NoContentAvailable({
  title,
  message,
}: {
  title: string
  message: string
}) {
  return (
    <main className="flex h-screen w-screen items-center justify-center bg-cover p-3">
      <div className="flex w-fit grow items-center justify-center gap-4 rounded-lg border bg-white shadow-md sm:grow-0">
        <div className="w-full max-w-md space-y-4 rounded-lg bg-card px-6 py-8 text-center shadow-lg">
          <AlertCircle className="mx-auto size-12 text-primary" />
          <h1 className="mt-4 text-2xl font-bold tracking-tight text-foreground lg:text-3xl">
            {title}
          </h1>
          <p className="mt-2 text-base text-muted-foreground">
            {message}
          </p>
          <Button asChild>
            <Link to="/">Voltar para login</Link>
          </Button>
        </div>
      </div>
    </main>
  )
}
